export default __webpack_public_path__ + "static/icon-palm-large-1f0d9076570fb23ad159c26ccd09f7fb.svg";